<div :class="$style.uploaderParentContainer">
  <div id="qq-foundry-uploader-zone" :class="$style.uploaderZone">
    <div
      :id="[imgPriority === 1 ? $vId(this, 'logo-choose') : $vId(this, 'banner-choose')]"
      class="qq-uploader-selector qq-upload-button-selector" :class="$style.uploaderSelector" >
      <div v-if="isimageUpdateText" :class="$style.uploadImg">
        <span :class="$style.uploadNewImg"></span>
        <p :class="$style.uploadNewImgText">{{$t('pages.profile.imageupdatetext')}}</p>
      </div>
      <div v-else-if="isNewimageUploadText" :class="$style.uploadImgWithoutBanner" id="imgUploadWithoutBanner">
        <div :class="$style.uploadfuncWithoutBannerImg">
          <div :class="$style.uploadcontainerWithoutBanner">
            <span :class="$style.cameraWithoutBannerImg"></span>
            <p :class="$style.cameratextWithoutBannerImg">{{$t('pages.profile.imageuploadtext')}}</p>
          </div>
        </div>
      </div>
      <div v-else-if="islogoUploadText">
        <div>
          <div :class="$style.uploadprofileImage">
            <span :class="$style.uploadedit"></span>
            <p :class="$style.uploadprofileImageHeading">{{texttoDisplay}}</p>
          </div>
        </div>
        <!-- <p>Hello</p> -->
      </div>
      <div
        class="qq-upload-drop-area-selector"
        :class="$style.uploadZoneArea" qq-hide-dropzone>
        <span class="qq-upload-drop-area-text-selector"></span>
      </div>
      <ul
        class="qq-upload-list-selector"
        role="region"
        aria-live="polite"
        aria-relevant="additions removals">
      </ul>
    </div>
  </div>
</div>
